import "animate.css";
import { useAppSelector } from "../../../globalState/hook";
import { Navigate } from "react-router-dom";
import { VerifyPhoneForm } from "../../../App/AppPhoneChecker";
import translator from "../../Extra/Translation/Translate";

const VerifyPhone = () => {
    const { translate } = translator();
    const { user } = useAppSelector((store) => store.auth);
    if (user && user.phoneVerified) return <Navigate to={`/dashboard`} />;
    if (!user?.phone) return <Navigate to={`/set-phone-number`} />;

    return (
        <div className=" opacity-90 rounded-xl h-[80vh] justify-center content-center mt-24 md:!mb-20 m-0 md:!pb-0 pb-24 lg:!mx-32 md:!mx-8 md:!px-24 px-2 shadow-lg">
            <section className="flex flex-col py-10  ">
                <div className="w-full flex flex-col-reverse lg:flex-row justify-between lg:!gap-7 md:!gap-3 gap-1 items-center mb-16">
                    <div data-aos="zoom-in" className="md:!w-1/2  md:!mt-0">
                        <h2 className="text-xl lg:block  text-center md:!text-left ml-2 md:!ml-0 md:!text-5xl md:!items-center font-extrabold lg:!leading-[70px] text-white">
                            {translate(
                                "PhoneVerification",
                                "verify_your_phone",
                            )}
                        </h2>
                    </div>
                    <div
                        data-aos="zoom-in-left"
                        className="lg:!w-2/5 ml-0 lg:-ml-40 lg:mt-0"
                    >
                        <div className="w-full flex flex-col-reverse lg:flex-row justify-center  lg:!gap-7 md:!gap-3 gap-1 items-center ">
                            <VerifyPhoneForm />
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default VerifyPhone;
